module.exports = __webpack_public_path__ + "img/120.4e7be39b.jpg";